import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

export default function BottomSlideIn({ children }) {
    const [rendered, setRendered] = useState(false);
    const [exiting, setExiting] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setTimeout(function() {
            setRendered(true);
         }, 100);
    }, []);


    const handleKeyDown = (e) => {
        window.removeEventListener('keydown', handleKeyDown);

        if (e.key === 'Escape') {
            handleExit();
        }
    }

    window.addEventListener('keydown', handleKeyDown);
        

    const handleExit = () => {
        navigate('/portal/students/update-student-progress', { state: { from: location } });
    };

    return (
        <div className="pop-up-fixed-back">
            <CSSTransition
                in={rendered}
                classNames={"slide"}
                timeout={1000}
            >
                <div className="pop-up-cont bottomSlideIn" style={{ background: 'transparent' }}>
                    <div className="inner">
                        {children}
                    </div>
                </div>
            </CSSTransition>
        </div>

    );
}
